import React from "react";
import { withERPSBaseDiv } from "../../hoc/withERPSBaseDiv";

function ERPSBaseDiv(props) {
  const { children, ...rest } = { children: props.children, key: props.key };
  return <React.Fragment {...rest}>{children}</React.Fragment>;
}

export default withERPSBaseDiv(ERPSBaseDiv);
